var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolderFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.18162 3.142L2.18163 3.142C2.45469 2.88916 2.82127 2.75 3.2 2.75H6.09666L7.95362 4.43815L8.09666 4.56818H8.28996H12.8C13.1787 4.56818 13.5453 4.70733 13.8184 4.96019C14.0923 5.2138 14.25 5.56198 14.25 5.92929V11.8889C14.25 12.2562 14.0923 12.6044 13.8184 12.858C13.5453 13.1109 13.1787 13.25 12.8 13.25H3.2C2.82125 13.25 2.45468 13.1109 2.18163 12.858L1.84278 13.224L2.18163 12.858C1.9077 12.6044 1.75 12.2562 1.75 11.8889V4.11111C1.75 3.74381 1.90769 3.39563 2.18162 3.142Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolderFilled);
export default ForwardRef;